import * as theme from "../theme";
import "react-perfect-scrollbar/dist/css/styles.css";
import BugReportNavTab from "./BugReportNavTab";
import { getBrokerInformation } from "../store/broker";
import { useDispatch, useSelector } from "react-redux";
import translations from "../utils/translations";

// Adapted from QFNavigation

const BugReportNavigation = ({ formQuestions, openFormId, onHeaderClick }) => {
  const infoHeight = "20%";
  const navhght = `calc(100% - ${infoHeight})`;
  const brokerInformation = useSelector(getBrokerInformation);
  const languagepreference =
    brokerInformation?.information?.languagepreference || "en";

  return (
    <div
      style={{
        ...theme.fwfh,
        display: "flex",
        flexDirection: "column",
        fontFamily: "GibsonRegular",
      }}
    >
      <div
        style={{
          width: "100%",
          height: infoHeight,
          padding: "10%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "50%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              fontFamily: "GibsonSemiBd",
              letterSpacing: 1,
              color: theme.COLORS.primary_navyblue,
              fontSize: "1.9vmin",
              paddingBottom: "18px",
            }}
          >
            {translations[languagepreference].feedbackHeader}
          </div>
          <div
            style={{
              width: "100%",
              fontFamily: "GibsonLight",
              letterSpacing: 1,
              fontSize: "1.6vmin",
              color: "grey",
              lineHeight: 1.3,
            }}
          >
            {translations[languagepreference].feedbackQuestion}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: "50%",
            display: "flex",
            fontSize: "1.3vmin",
            color: "grey",
            fontFamily: "GibsonLight",
            paddingTop: "1vmin",
          }}
        ></div>
      </div>
      <div
        style={{
          width: "100%",
          height: navhght,
          backgroundColor: theme.COLORS.primary_navyblue,
          color: "white",
          letterSpacing: 1,
        }}
      >
        {formQuestions.map((obj, id) => (
          <BugReportNavTab
            key={id}
            formid={id}
            text={obj.header[languagepreference]}
            openFormId={openFormId}
            onHeaderClick={onHeaderClick}
          ></BugReportNavTab>
        ))}
      </div>
    </div>
  );
};

export default BugReportNavigation;
